import axios from 'axios'
import { Toast, Dialog } from 'vant'
import store from '../store'
import { getWeixInfo } from '@/utils/auth'
// const Key =
// import router from '@/router'
// 创建axios实例
const service = axios.create({
  // baseURL: (window.BASE_URL || process.env.VUE_APP_BASE_URL) + process.env.VUE_APP_BASE_API,
  baseURL: process.env.VUE_APP_BASE_URL + process.env.VUE_APP_BASE_API,
  timeout: 15000 // 请求超时时间
})
// request拦截器
service.interceptors.request.use(config => {
  if (getWeixInfo()) {
    config.headers['Key'] = JSON.parse(getWeixInfo()).Key // 让每个请求携带自定义token
  }
  return config
}, error => {
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    /**
     * Success为非1是抛错
     */
    if (response.headers['content-type'] === 'application/vnd.ms-excel') {
      return response
    } else {
      const res = response.data
      if (res.Success === 1 && res.Status === 1) {
        if (res.Status !== 1) {
          Toast.fail(res.Message)
        }
        return response.data
      } else {
        // 错误提示
        if (res.Status !== 1) {
          // 3登录失效
          if (res.Status === 3) {
            Dialog.alert({
              title: '系统提示',
              message: '登录超时！'
            }).then(() => {
              store.dispatch('FedLogOut').then(() => {
                window.location.href='/#/bindingLogin'
                // location.reload()// 为了重新实例化vue-router对象 避免bug
              })
            })
            return false
          }
          if(res.Message !== '未找到手机号' && response.config.url.indexOf('/BizMemberReturn/YyRemitQuery') < 0) {
            Toast.fail(res.Message)
          }
        } else {
          Toast.success(res.Message)
        }
      }
      return response.data
    }
  },
  error => {
    Toast.fail(error.message)
    return Promise.reject(error)
  }
)

export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    service.get(url, {
      params: params
    })
      .then(response => {
        resolve(response)
      })
      .catch(err => {
        reject(err)
      })
  })
}
// export function get(url, bool, params, responseType = { }) {
//   return new Promise((resolve, reject) => {
//     if (bool) {
//       params.Key = getToken()
//     }
//     service.get(url, { params: params }, responseType)
//       .then(response => {
//         resolve(response)
//       })
//       .catch(err => {
//         reject(err)
//       })
//   })
// }

export function post(url, data = {}, bool = true, responseType = { }) {
  return new Promise((resolve, reject) => {
    // if (bool) {
    //   data.Key = getToken()
    // }
    service.post(url, data, responseType, {timeout: 1})
      .then(response => {
        resolve(response)
      }, err => {
        reject(err)
      })
  })
}

export function patch(url, data = {}) {
  return new Promise((resolve, reject) => {
    service.patch(url, data)
      .then(response => {
        resolve(response)
      }, err => {
        reject(err)
      })
  })
}

export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    service.put(url, data)
      .then(response => {
        resolve(response)
      }, err => {
        reject(err)
      })
  })
}

export default service
